import Platform from './Platform'
import * as nativeApi from '../../api/index'
import * as nativeComponentApi from '../../api/nativeComponentAPI'

class Ios extends Platform {
  constructor() {
    super()
  }

  // IOS 下禁用页面滑动反弹
  toggleBouncesOff() {
    nativeApi.toggleBouncesOff()
  }

  // IOS 下启用页面滑动反弹
  toggleBouncesOn() {
    nativeApi.toggleBouncesOn()
  }

  /**
    * 预加载storeKit
    * @param params
    * @returns {*|Promise<any>}
    */
  preloadStoreKit (params = {}) {
    nativeComponentApi.preloadStoreKit(params)
  }

  /**
  * 添加stk到父视图
  * @param params
  * @returns {*|Promise<any>}
  */
  addStoreKitTo (params = {}) {
    nativeComponentApi.addStoreKitTo(params)
  }

  /**
   * 为increaseOfferFrequenceForRvIv接口组成要发送的数据
   * @param campaign {Object}
   */
  prepareDataForIncOfferFreRvIv(campaign = {}) {
    const dataSend = {
      data: campaign
    }
    return dataSend
  }

  /**
   * ios: ivRewardEnable=true
   * Android: ivRewardEnable=1
   * @returns {number}
   */
  getIvRewardEnable() {
    console.log('Platform: ios: getIvRewardEnable')
    let ivreward = this.getIvreward()
    let ivRewardEnable = ivreward.ivRewardEnable;
    if (ivRewardEnable === true || ivRewardEnable === 1) {
      return 1
    } else {
      return 0
    }
  }

  /**
   * alert rate or alert time
   * @returns {*}
   */
  getIvRewardPlayValue () {
    let ivreward = this.getIvreward()
    return ivreward.ivRewardPlayValue
  }

  getFilePathByRemoteUrlForRvIv(resParam = { url: '', type: 2 }) {
    return new Promise(resolve=>{
      super.getFilePathByRemoteUrlForRvIv(resParam).then((ret) => {
        const data = {
          path: ret.path4Web,
          path4Web: ret.path4Web,
          decodeUrl: ret.path,
          downloaded: ret.downloaded,
        }
        resolve(data)
      })
    })
  }

  addStoreKitTo(params = {}) {
    return nativeComponentApi.addStoreKitTo(params)
  }

  getDevMuteSetting() {
    return this.fetchInitData({h5cbp:1}).then((data) => data.sdkSetting.playVideoMute)
  }
}

export default Ios